import React from 'react'
import Popup from '../components/Popup'
import Button from '../components/Button'
import SquareContainer from '../components/SquareContainer'
import ConfigurableProductView from '../components/ConfigurableProductView'
import { getDefaultSkinOrientation } from '../products/productUtils'
import { getSkinErrorImage, getSkinPlaceholderImage } from '../data/test-data'
import ConfigurableProductButton from '../components/ConfigurableProductButton'
import { InflatedListItemProduct } from './ListTypes'

const DeleteProductPopup: React.FC<{
  onClose: () => void
  onConfirm: () => void
  configuredProduct: InflatedListItemProduct
}> = ({
  onClose,
  onConfirm,
  configuredProduct,
}) => {
  return (
    <Popup onClose={onClose}>
      <div className="subtitle">
        Are you sure you want to remove this from your list?
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
        <SquareContainer size="120px">
          <ConfigurableProductView
            shadowScale={0.3}
            {...configuredProduct.skinProduct}
            orientation={configuredProduct.skinProduct.orientation}
            buttonCoordsOrientation={getDefaultSkinOrientation(configuredProduct.skinProduct)}
            image={configuredProduct.skinProduct.image}
            placeholderImage={getSkinPlaceholderImage(configuredProduct.skinProduct, configuredProduct.skinProduct.gridProduct)}
            errorImage={getSkinErrorImage(configuredProduct.skinProduct, configuredProduct.skinProduct.gridProduct)}
            renderButton={(buttonConfig, buttonIndex, scale, shadowScale) => {
              const { interfaceProduct } = configuredProduct.configuredButtons[buttonIndex]
              return (
                <ConfigurableProductButton
                  baseScale={scale}
                  shadowScale={shadowScale}
                  {...buttonConfig}
                  // backgroundImage={buttons[buttonIndex].mechImageUrl}
                  foregroundImage={interfaceProduct.image}
                  debugColorCode={interfaceProduct.color}
                />
              )
            }}
          />
        </SquareContainer>
      </div>
      <div className="buttonStack">
        <div className="buttonRow">
          <Button
            onClick={onClose}
          >
            Keep
          </Button>
          <Button
            buttonStyle="redStroke"
            onClick={onConfirm}
          >
            Remove
          </Button>
        </div>
      </div>
    </Popup>
  )
}

export default DeleteProductPopup
